import styled, { css } from 'styled-components'
import { Heading, Text } from 'vvs-uikit'

export const ControlContainer = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  width: 100%;
  align-items: center;
  position: relative;

  justify-content: space-between;
  flex-direction: column;
  margin-bottom: 32px;

  ${({ theme }) => theme.mediaQueries.sm} {
    flex-direction: row;
    flex-wrap: wrap;
    padding: 16px 0px 16px 0px;
    margin-bottom: 0;
  }
`

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;

  ${Text} {
    margin-left: 8px;
  }
`

export const LabelWrapper = styled.div`
  flex: 1;
  > ${Text} {
    font-size: 12px;
  }
`

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 0px;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 8px 10px;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    width: auto;
    padding: 0;
  }
`

export const ViewControls = styled.div`
  flex-wrap: wrap;
  justify-content: space-between;
  display: flex;
  align-items: center;
  width: 100%;

  > div {
    padding: 8px 0px;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    justify-content: flex-start;
    width: auto;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    > div {
      padding: 0;
    }
  }
`

export const StyledHeading = styled(Heading)<{ weight?: number }>`
  color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ weight }) => weight ?? 'normal'};
`

export const LegendaryColor = css`
  background: linear-gradient(89.96deg, #4799cc 0.03%, #ffd600 99.83%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
`

export const EpicColor = css`
  color: ${({ theme }) => theme.colors.blue};
`

export const RareColor = css`
  color: ${({ theme }) => theme.colors.legendary};
`

export const SpecialColor = css`
  color: ${({ theme }) => theme.colors.success};
`

export const CommonColor = css`
  color: ${({ theme }) => theme.colors.text};
`
